import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ScrollService {
	constructor() {}

	scroll: { xpos: number; ypos: number; url: string; trigger: boolean };
	private listState: any = {};
	AdListPageNumber: number;
	HomePageNumber: number;

	save(xpos: number, ypos: number, url: string, trigger: boolean = false) {
		this.scroll = {
			xpos: xpos === null ? this.scroll.xpos : xpos,
			ypos: ypos === null ? this.scroll.ypos : ypos,
			url: url === null ? this.scroll.url : url,
			trigger: trigger,
		};

		localStorage.setItem('scrollPosition', JSON.stringify(this.scroll));
	}

	fetch(): Object {
		this.scroll = JSON.parse(localStorage.getItem('scrollPosition'));
		return this.scroll;
	}

	saveListState(state: any) {
		this.listState = state;
	}

	getListState() {
		return this.listState;
	}

	saveAdListPageNo(page: number) {
		this.AdListPageNumber = page;
	}

	getAdListPageNo() {
		return this.AdListPageNumber;
	}

	saveHomeListPageNo(page: number) {
		this.HomePageNumber = page;
	}

	getHomePageNo() {
		return this.HomePageNumber;
	}
}